import { enUS, es, Locale } from 'date-fns/locale';
import { SupportedLocale } from './config';

export const DATE_FNS_LOCALES: Record<SupportedLocale, Locale> = {
  [SupportedLocale.EnUs]: enUS,
  [SupportedLocale.EsEs]: es,
};

export const dateFnsLocaleFor = (locale: SupportedLocale): Locale => DATE_FNS_LOCALES[locale];
